import React from 'react';
import BoostedComponent from './BoostedComponent';


class ReservationSeuleDispo extends BoostedComponent {
  constructor (props) {
    super(props)

    this.constants = this.props.constants;

    this.state = {
      debutMonth: 0,
      debutYear: 0,
      moisCourrant: 0,
      anneeCourrante: 0,
      heureDebut: '',
      heureFin: '',
      activites: [],
      dayLabels: this.constants.shortdays
    }
    this.maxMonth = this.constants.options.moisMax

    let now =  new Date();
    now.setUTCDate(now.getUTCDate()+1)
    this.state.debutMonth = now.getMonth()
    this.state.debutYear = now.getFullYear()
    this.state.moisCourrant = now.getMonth()
    this.state.anneeCourrante = now.getFullYear()

    this.semaines = [];
    for (let i=0; i < 24;i++) {
      this.semaines.push(i+":00",i+":30")
    }
    this.semaines.push("24:00")
  }
  componentDidUpdate = (prevProps,prevState) => {
    if (
      prevState.heureDebut !== this.state.heureDebut ||
      prevState.heureFin !== this.state.heureFin ||
      prevState.moisCourrant !== this.state.moisCourrant
      ) {
      this.props.parent.setState({
          view: 0,
          au: null,
          du: null,
          jourChoisi: null, 
          aReserver: [],
          plageChoisie: null,
          exact: null
      })
  }

    if (
      prevState.moisCourrant!==this.state.moisCourrant ||
      prevState.anneeCourrante!==this.state.anneeCourrante
    ) {
      this.loadNewActivites()
    }

    if (this.props.jourChoisi !== this.state.jourChoisi) {
      if (this.props.jourChoisi) {
        let [y,m,d] = this.props.jourChoisi

        this.setState({
          jourChoisi: this.props.jourChoisi,
          moisCourrant: m,
          anneeCourrante: y
        })
        if (this.props.parent.state.jourChoisi !== this.props.jourChoisi) {

          this.props.parent.setState({
            jourChoisi: [y,m,d],
          })
        }
      }
    }
    if (this.state.heureDebut !== prevState.heureDebut ) {
      this.props.parent.setState({
        heureDebut: this.state.heureDebut,
      });
    }
    if (this.state.heureFin !== prevState.heureFin ) {
      this.props.parent.setState({
        heureFin: this.state.heureFin,
      });
    }
    if (this.state.heureDebut && this.state.heureFin) {
      if (window.jQuery(window).width() < 768 && window.location.hash=="#single0") {
        window.jQuery("html,body").animate({scrollTop: window.jQuery(".tableauDispo").offset().top},300)
        window.location.hash = "single0-A"
      }
    }
  }
  componentDidMount() {
    this.loadNewActivites();
  }
  loadNewActivites = () => {
    let debut = new Date(Date.UTC(this.state.anneeCourrante,this.state.moisCourrant,1,0,0,0,0))
    let fin = new Date(Date.UTC(this.state.anneeCourrante,this.state.moisCourrant+1,1,0,0,0,0))
    this.setState({
      activites: null
    })
    window.jQuery.ajax({
      dataType: 'json',
      url: this.props.constants.ajaxurl,
      method: 'POST',
      crossDomain: true,
      data: {

          plateaux: this.props.constants.plateaux,
        action: 'schedulePublicGetActivities',
        from: debut.getTime()/1000,
        to: fin.getTime()/1000
      },
      success: (response) => {
        response.forEach(i=>{
          i.debut = parseInt(i.debut)
          i.fin = parseInt(i.fin)
        })
        this.setState({
          activites: response
        })
        this.props.parent.setState({
          activites: response
        })
      }
    });
  }  
  generateMonthList = (e) => {
    var months = this.constants.moisLabel;
    let month = this.state.debutMonth;
    let year = this.state.debutYear;
    let monthlist = [];
    while (this.maxMonth*1000 > Date.UTC(year, month, 0, 0,0,0,0)) {
      monthlist.push({
        value: year+"-"+month,
        name: months[month],
        year: year
      })
      month++;
      if (month===12) {
        month=0;
        year++;
      }
    }
    return  monthlist
  }
  handleMonthChange = (event) => {
    let v = event.target.value.split("-");
    this.setState({
      anneeCourrante: parseInt(v[0]),
      moisCourrant: parseInt(v[1]),
    })
  }
  buildCalendar = (b,c,d,e) => {
    let a = new Date(Date.UTC(this.state.anneeCourrante,this.state.moisCourrant,1,0,0,0,0));
    let moisCourrant = a.getUTCMonth()
    let month = [];
    let week = [null,null,null,null,null,null,null];
    while (a.getUTCMonth() ===  moisCourrant ) {
      if (a.getUTCDay()===0 && a.getUTCDate()>1) {

        month.push(week)
        week = [null,null,null,null,null,null,null]
      }

      week[a.getUTCDay()] = a.getUTCDate();
      a.setUTCDate(a.getUTCDate()+1)
    }
    month.push(week)
    return month
  }
  evaluerJour = (e) => {

    if (Date.UTC(this.state.anneeCourrante,this.state.moisCourrant,e,0,0,0,0)< Date.now()+(this.constants.options.delay*1000*24*60*60)) return (
      <span>{e}</span>
    )
    if (Date.UTC(this.state.anneeCourrante,this.state.moisCourrant,e,0,0,0,0)>this.maxMonth*1000) return (
      <span>{e}</span>
    )

    if (!e) return (
      <span>{e}</span>
    )

    let dispo = "red"
    let heureDebut = this.state.heureDebut.split(':');
    let heureFin = this.state.heureFin.split(':');

    if (parseInt(heureFin[0])===0 && parseInt(heureFin[1])===0) {
      heureFin[0] = 24;
    }
    let matin = Date.UTC(this.state.anneeCourrante,this.state.moisCourrant,e,0,0,0,0);
    let soir = Date.UTC(this.state.anneeCourrante,this.state.moisCourrant,e+2,0,0,0,0);

    matin = matin/1000;
    soir = soir/1000;

    let filter = (item) => {
      return (item.fin > matin && item.debut < soir)
    }

    let debut = new Date(Date.UTC(this.state.anneeCourrante,this.state.moisCourrant,e,parseInt(heureDebut[0]),parseInt(heureDebut[1]),0));
    let fin = new Date(Date.UTC(this.state.anneeCourrante,this.state.moisCourrant,e,parseInt(heureFin[0]),parseInt(heureFin[1]),0));

    debut = debut.getTime()/1000;
    fin = fin.getTime()/1000;



    let originalfin = fin;
    let originaldebut = debut 

    for (let p=0;p< this.constants.plateaux.length;p++) {
      let plateau = parseInt(this.constants.plateaux[p]);
      let conflictingactivite = this.state.activites.filter(filter).filter(i=>(parseInt(i.plateau_ID,10)===plateau)).filter(i=>(
        (parseInt(i.debut) <= debut && debut < parseInt(i.fin)) ||
        (parseInt(i.debut) < fin && fin <= parseInt(i.fin)) ||
        (debut <= parseInt(i.debut) && parseInt(i.debut) < fin) ||
        (debut < parseInt(i.fin) && parseInt(i.fin) <= fin)
      ));

let newDebut = debut%(24*60*60)

if (newDebut < this.constants.options.heureDebut) newDebut = newDebut + 24*60*60

      if (conflictingactivite.length === 0 && newDebut >= ( this.constants.options.heureDebut *60*60)) {
        dispo = "green"
        break; 
      }
      else {
        let debut = originaldebut - (this.constants.options.chercherPlusHeures*60*60);
        let fin = originalfin - (this.constants.options.chercherPlusHeures*60*60);
console.log(debut, fin);


        for (let offset=0;offset<(this.constants.options.chercherPlusHeures*8);offset++) {

          debut = debut + (15*60)
          fin = fin + (15*60)

          

          let jour = debut - debut%(24*60*60);
          
          if (
            debut%(24*60*60) >= (this.constants.options.heureDebut*60*60) && fin-jour <= (this.constants.options.heureFin*60*60)) {
              jour = 0;
              

            let conflictingactivite = this.state.activites.filter(filter).filter(i=>(parseInt(i.plateau_ID,10)===plateau)).filter(i=>(
              (parseInt(i.debut) <= debut && debut < parseInt(i.fin)) ||
              (parseInt(i.debut) < fin+jour && fin+jour <= parseInt(i.fin)) ||
              (debut <= parseInt(i.debut) && parseInt(i.debut) < fin+jour) ||
              (debut < parseInt(i.fin) && parseInt(i.fin) <= fin+jour)
            ));
            if (conflictingactivite.length === 0) {
              dispo = "yellow"
              break;
            }
          }
        }

      }
    }
    let action = this.selectionnerDate.bind(this,this.state.anneeCourrante,this.state.moisCourrant,e);
    if (dispo==="red") {
      return (
        <span className={dispo}>{e}</span>
      );
    }


    return (
      <span className={dispo} onClick={action}>{e}</span>
    );
  }
  selectionnerDate = (y,m,d) => {
    this.setState({
      jourChoisi: [y,m,d]
    });

    this.props.parent.setState({
      jourChoisi: [y,m,d],
      plageChoisie: null,
      view: 1
    })

  }
  calculDuree = (a,b) => {
    if (! this.state.heureDebut || !  this.state.heureFin) return "";
    let heureDebut = this.state.heureDebut.split(':');
    let heureFin = this.state.heureFin.split(':');

    if (parseInt(heureFin[0])===0 && parseInt(heureFin[1])===0) {
      heureFin[0] = this.constants.options.heureFin;
    }

    let debut = parseInt(heureDebut[0]) + parseInt(heureDebut[1])/60
    let fin = parseInt(heureFin[0]) + parseInt(heureFin[1])/60;
    if (fin < debut) {
      this.setState({
        SelectionHeureDebut: this.state.heureFin,
        SelectionHeureFin: this.state.heureDebut
      })
    }
    let mins = "0"+((fin - debut - Math.floor(fin - debut))*60)

    return Math.floor(fin - debut)+":"+mins.substring(mins.length-2)

  }
  handleDureeChange = (event) => {
    const target = event.target;
    let value = target.value;

    let fin = this.temps2string((this.string2temps(this.state.heureDebut)+ this.string2temps(value))*60*60,1)

    this.setState({
      heureFin: fin
    });
    window.wasModified = true;
  }

  render() {
    return(
      <div>
        <div className="label">
          <label>{this.constants.mois}</label>
          <select onChange={this.handleMonthChange} value={this.state.anneeCourrante+"-"+this.state.moisCourrant}>
            {
              this.generateMonthList(this.state).map(m=>
                <option key={m.value} value={m.value}>{m.name} {m.year}</option>
              )
            }
          </select>
        </div>
        <div className="fieldLine">
          <div className="label">
            <label>{this.constants.heureDebutActiv}</label>
            <select onChange={(e)=>{

                  let nouveauTemps;

                    nouveauTemps = this.string2temps(e.target.value) + (this.string2temps(this.state.heureFin || 0) - this.string2temps(this.state.heureDebut || 0));

//                  if (nouveauTemps > 24) nouveauTemps = this.string2temps(e.target.value);
let newFin =  (this.state.heureFin) ? this.temps2string(nouveauTemps*3600,false) : ""; 

if (this.string2temps(newFin) > this.constants.options.heureFin) { 
 this.refs.selectFin.value = this.temps2string((parseInt(this.constants.options.heureFin)-this.string2temps(e.target.value))*3600, false)
 newFin = this.temps2string(parseInt(this.constants.options.heureFin)*3600)
}  

                  this.setState({
                    heureDebut: e.target.value,
                    heureFin: newFin
                  })



              }} value={this.state.heureDebut}>
              {!this.state.heureFin && <option value=""></option>}
              {this.semaines.filter(i=>{
                if (this.string2temps(i) > this.constants.options.heureFin - 1) return false;
                if (this.string2temps(i)< this.constants.options.heureDebut) return false;
                return true;
              }).map(i => {
                if (this.string2temps(i)<10) return '0'+i;
                return i;
              }).map(i=>
                <option key={i} value={i}>{i}</option>
              )}
            </select>
          </div>
          <div className="label">
            <label>{this.constants.dureeActiv}</label>
            <select onChange={this.handleDureeChange} ref="selectFin">
              {!this.state.heureFin && <option value=""></option>}
              {this.semaines.slice(2).filter(i=>{




                //return true;

                if (!this.state.heureDebut) return true;
                let time1 = i.split(":")
                time1 = parseInt(time1[0])+ (parseInt(time1[1])/60)

                let time2 = this.state.heureDebut.split(":")
                time2 = parseInt(time2[0])+ (parseInt(time2[1])/60)

                
                let time3 = 0
                if (this.state.duree) {
                  time3 = this.state.duree.split(":")
                  time3 = parseInt(time3[0])+ (parseInt(time3[1])/60)
                }

                return time2+time1 <= this.props.constants.options.heureFin;

              }).map(i=>
                <option key={i} value={i}>{i}</option>
              )}
            </select>
          </div>
        </div>
        { this.state.heureDebut && this.state.heureFin &&
          <div className="tableauDispo">
            <h3>{this.constants.disponibilite}</h3>
            <p>{this.constants.disponibiliteInstructions}</p>
            <div className="moisTitre">
              { (this.state.moisCourrant !== this.state.debutMonth || this.state.anneeCourrante !== this.state.debutYear) &&
                <button
                  onClick={(e)=>{
                    if (this.state.moisCourrant===0) {
                      this.setState({
                        moisCourrant: 11,
                        anneeCourrante: this.state.anneeCourrante - 1
                      })
                    } else {
                      this.setState({
                        moisCourrant: this.state.moisCourrant - 1
                      })
                    }
                  }}>
                  &#8249; {this.constants.prev}
                </button>
              }
              <span>
                { this.constants.moisLabel[this.state.moisCourrant]}
              </span>
              { (this.maxMonth*1000 > Date.UTC(this.state.anneeCourrante, this.state.moisCourrant+1, 0, 0,0,0,0)) &&
                <button onClick={(e)=>{
                    if (this.state.moisCourrant===11) {
                      this.setState({
                        moisCourrant: 0,
                        anneeCourrante: this.state.anneeCourrante +1
                      })
                    } else {
                      this.setState({
                        moisCourrant: this.state.moisCourrant + 1
                      })
                    }
                  }}>
                  {this.constants.next} &#8250;
                </button>
              }
            </div>
            {this.state.activites &&
              <React.Fragment>
                <table>
                  <thead>
                    <tr>
                      {this.state.dayLabels.map((i,index)=>
                        <th key={index}>{i}</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {this.buildCalendar(this.state.heureFin,this.state.heureDebut,this.state.moisCourrant,this.state.anneeCourrante).map((w,index)=>
                      <tr key={index}>
                        {
                          w.map((d,index)=><td key={index}>{this.evaluerJour(d)}</td>)
                        }
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="ReservationSingleLegende">

                  <div className="option1"><span>{this.constants.option4}</span></div>
                  <div className="option2"><span>{this.constants.option5}</span></div>
                  <div className="option3"><span>{this.constants.option6}</span></div>

                </div>
              </React.Fragment>
            }
          </div>
        }
      </div>
    )
  }
}
export default ReservationSeuleDispo;



// WEBPACK FOOTER //
// ./src/ReservationSeule1.js